import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import AdvisorServicePage from "./modules/ContentManager/advisorServices/AdvisorServicePage";
import EditAdvisorService from "./modules/ContentManager/advisorServices/EditAdvisorService";
import ContactsPage from "./modules/ContentManager/contacts/ContactsPage";
import WatchContactPage from "./modules/ContentManager/contacts/WatchContactPage";
import CountryPage from "./modules/ContentManager/country/CountryPage";
import EditCountryPage from "./modules/ContentManager/country/EditCountryPage";
import CustomersPage from "./modules/ContentManager/customers/CustomersPage";
import EditCustomerPage from "./modules/ContentManager/customers/EditCustomerPage";
import DevelopmentStatusPage from "./modules/ContentManager/developmentStatus/DevelopmentStatusPage";
import EditDevelopmentStatusPage from "./modules/ContentManager/developmentStatus/EditDevelopmentStatusPage";
import BusinessAreasPage from "./modules/ContentManager/businessArea/BusinessAreaPage";
import EditBusinessAreasPage from "./modules/ContentManager/businessArea/EditBusinessAreaPage";
import EditLanguagesPage from "./modules/ContentManager/languages/EditLanguagesPage";
import LanguagesPage from "./modules/ContentManager/languages/LanguagesPage";
import EditLocalidadesPage from "./modules/ContentManager/localidades/EditLocalidadesPage";
import LocalidadesPage from "./modules/ContentManager/localidades/LocalidadesPage";
import EditProjectsPage from "./modules/ContentManager/projects/EditProjectsPage";
import ProjectsPage from "./modules/ContentManager/projects/ProjectsPage";
import EditProvinciasPage from "./modules/ContentManager/provincias/EditProvinciasPage";
import ProvincePage from "./modules/ContentManager/provincias/ProvincePage";
import EditTechnologyPage from "./modules/ContentManager/technologies/EditTechnologyPage";
import TechnologyPage from "./modules/ContentManager/technologies/TechnologyPage";
import EditTextsPage from "./modules/ContentManager/texts/EditTextsPage";
import TextsPage from "./modules/ContentManager/texts/TextsPage";
import { DashboardPage } from "./pages/DashboardPage";
import PartnersPage from "./modules/ContentManager/partner/PartnersPage";
import EditPartnersPage from "./modules/ContentManager/partner/EditPartnersPage";
import SubPlanPage from "./modules/ContentManager/subPlan/SubPlanPage";
import EditSubPlanPage from "./modules/ContentManager/subPlan/EditSubPlanPage";
import FeaturePage from "./modules/ContentManager/feature/FeaturePage";
import EditFeaturePage from "./modules/ContentManager/feature/EditFeaturePage";
import WebProjectPage from "./modules/ContentManager/webProject/WebProjectPage";
import EditWebProjectPage from "./modules/ContentManager/webProject/EditWebProjectPage";
import DealPage from "./modules/ContentManager/deals/DealPage";
import WatchDealPage from "./modules/ContentManager/deals/WatchDealPage";
import NewsPage from "./modules/ContentManager/news/NewsPage";
import EditNewsPage from "./modules/ContentManager/news/EditNewsPage";
import CategoryFaqsPage from "./modules/ContentManager/categoryFaqs/CategoryFaqsPage";
import EditCategoryFaqsPage from "./modules/ContentManager/categoryFaqs/EditCategoryFaqsPage";
import ManufacturersPage from "./modules/ContentManager/manufacturers/ManufacturersPage";
import EditManufacturerPage from "./modules/ContentManager/manufacturers/EditManufacturerPage";
import ProjectTitlesPage from "./modules/ContentManager/projectTitles/ProjectTitlesPage";
import EditProjectTitle from "./modules/ContentManager/projectTitles/EditProjectTitle";
import DealAdvisorPage from "./modules/ContentManager/dealAdvisor/DealAdvisorPage";
import WatchDealAdvisorPage from "./modules/ContentManager/dealAdvisor/WatchDealAdvisor";
import ActiveUsersPage from "./modules/ContentManager/activeUsers/ActiveUserPage";
import SubscriptionPaymentsPage from "./pages/SubscriptionPaymentsPage";

export default function BasePage() {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const isAdmin = user || user?.role !== "admin";

  return (
    <Switch>
      {/* Redirect from root URL to /dashboard. */}
      <Redirect exact from="/" to="/dashboard" />
      <ContentRoute path="/dashboard" component={DashboardPage} />
      <ContentRoute path="/subscription-payments" component={SubscriptionPaymentsPage} />

      {/* USERS */}
      {/* Administrators */}
      <ContentRoute from="/admins" component={AdminsPage} />
      <ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />

      {/* Active users */}
      <ContentRoute from="/active-users" component={ActiveUsersPage} />

      {/* Sellers */}
      <ContentRoute from="/sellers" component={CustomersPage} />
      <ContentRoute from="/edit-seller/:id?" component={EditCustomerPage} />

      {/* Buyers */}
      <ContentRoute from="/buyers" component={CustomersPage} />
      <ContentRoute from="/edit-buyer/:id?" component={EditCustomerPage} />

      {/* Advisors */}
      <ContentRoute from="/advisors" component={CustomersPage} />
      <ContentRoute from="/edit-advisor/:id?" component={EditCustomerPage} />

      {/* Projects */}
      <ContentRoute from="/projects" component={ProjectsPage} />
      <ContentRoute from="/edit-project/:id?" component={EditProjectsPage} />

      {/* Deals */}
      <ContentRoute from="/deals" component={DealPage} />
      <ContentRoute from="/watch-deal/:id" component={WatchDealPage} />

      {/* Deals Advisor*/}
      <ContentRoute from="/advisorDeals" component={DealAdvisorPage} />
      <ContentRoute from="/watch-advisorDeals" component={WatchDealAdvisorPage} />

      {/* Contacts */}
      <ContentRoute from="/contacts" component={ContactsPage} />
      <ContentRoute from="/watch-contact/:id?" component={WatchContactPage} />


      {/* WEB */}
      {/* Partners */}
      <ContentRoute
        from="/partners"
        component={!isAdmin ? DashboardPage : PartnersPage}
      />
      <ContentRoute
        from="/edit-partner/:id?"
        component={!isAdmin ? DashboardPage : EditPartnersPage}
      />

      {/* Subscription plan */}
      <ContentRoute
        from="/subscriptionPlans"
        component={!isAdmin ? DashboardPage : SubPlanPage}
      />
      <ContentRoute
        from="/edit-subscriptionPlan/:id?"
        component={!isAdmin ? DashboardPage : EditSubPlanPage}
      />

      {/* Features plan */}
      <ContentRoute
        from="/features"
        component={!isAdmin ? DashboardPage : FeaturePage}
      />
      <ContentRoute
        from="/edit-feature/:id?"
        component={!isAdmin ? DashboardPage : EditFeaturePage}
      />

      {/* Web Projects */}
      <ContentRoute
        from="/webProjects"
        component={!isAdmin ? DashboardPage : WebProjectPage}
      />
      <ContentRoute
        from="/edit-webProject/:id?"
        component={!isAdmin ? DashboardPage : EditWebProjectPage}
      />

      {/* Texts */}
      <ContentRoute
        from="/texts"
        component={!isAdmin ? DashboardPage : TextsPage}
      />
      <ContentRoute
        from="/edit-text/:id"
        component={!isAdmin ? DashboardPage : EditTextsPage}
      />

      {/* Category Faq */}
      <ContentRoute
        from="/categoryFaqs"
        component={!isAdmin ? DashboardPage : CategoryFaqsPage}
      />
      <ContentRoute
        from="/edit-categoryFaq/:id?"
        component={!isAdmin ? DashboardPage : EditCategoryFaqsPage}
      />

      {/* News */}
      <ContentRoute
        from="/news"
        component={!isAdmin ? DashboardPage : NewsPage}
      />
      <ContentRoute
        from="/edit-news/:id?"
        component={!isAdmin ? DashboardPage : EditNewsPage}
      />


      {/* MISCELLANY */}
      {/* Project titles */}
      <ContentRoute
        from="/projectTitles"
        component={!isAdmin ? DashboardPage : ProjectTitlesPage}
      />
      <ContentRoute
        from="/edit-projectTitle/:id?"
        component={!isAdmin ? DashboardPage : EditProjectTitle}
      />
      {/* Technologies */}
      <ContentRoute
        from="/technologies"
        component={!isAdmin ? DashboardPage : TechnologyPage}
      />
      <ContentRoute
        from="/edit-technology/:id?"
        component={!isAdmin ? DashboardPage : EditTechnologyPage}
      />
      {/* Development status */}
      <ContentRoute
        from="/developmentStatus"
        component={!isAdmin ? DashboardPage : DevelopmentStatusPage}
      />
      <ContentRoute
        from="/edit-developmentStatus/:id?"
        component={!isAdmin ? DashboardPage : EditDevelopmentStatusPage}
      />
      {/* Advisor Services */}
      <ContentRoute
        from="/advisorServices"
        component={!isAdmin ? DashboardPage : AdvisorServicePage}
      />
      <ContentRoute
        from="/edit-advisorService/:id?"
        component={!isAdmin ? DashboardPage : EditAdvisorService}
      />
      {/* Business Areas */}
      <ContentRoute
        from="/businessArea"
        component={!isAdmin ? DashboardPage : BusinessAreasPage}
      />
      <ContentRoute
        from="/edit-businessArea/:id?"
        component={!isAdmin ? DashboardPage : EditBusinessAreasPage}
      />

      {/* Manufacturers */}
      <ContentRoute
        from="/manufacturers"
        component={!isAdmin ? DashboardPage : ManufacturersPage}
      />
      <ContentRoute
        from="/edit-manufacturer/:id?"
        component={!isAdmin ? DashboardPage : EditManufacturerPage}
      />

      {/* Languages */}
      <ContentRoute
        from="/languages"
        component={!isAdmin ? DashboardPage : LanguagesPage}
      />
      <ContentRoute
        from="/edit-language/:id?"
        component={!isAdmin ? DashboardPage : EditLanguagesPage}
      />

      {/* Paises */}
      <ContentRoute from="/countries" component={CountryPage} />
      <ContentRoute from="/edit-country/:id?" component={EditCountryPage} />

      {/* Provincias */}
      <ContentRoute from="/provinces" component={ProvincePage} />
      <ContentRoute
        from="/edit-province/:id?"
        component={EditProvinciasPage}
      />

      {/* Localidades */}
      <ContentRoute from="/cities" component={LocalidadesPage} />
      <ContentRoute
        from="/edit-city/:id?"
        component={EditLocalidadesPage}
      />

      <Redirect to="/error" />
    </Switch>
  );
}
